// auto-generated by Typewriter template _models.tst from PortCall.Models\TopicCards\TopicCardTemplateTimeEntry.cs
import S, { DataSignal } from 's-js';
import SArray, { SDataArray } from 's-array';
import TZDate from 'lib/TZDate';
import { jsonableObservable } from 'lib/jsonableObservable';


// TopicCardTemplateTimeEntryData is the class that TopicCardTemplateTimeEntry serializes to/from
export interface TopicCardTemplateTimeEntryData {
	
	
    HasTimeEntry : boolean;
    Label : string | null;
}

// TopicCardTemplateTimeEntryOptions is the class which may be passed to the TopicCardTemplateTimeEntry constructor to define optional initial data values
export interface TopicCardTemplateTimeEntryOptions {
	
	
    HasTimeEntry? : boolean;
    Label? : string | null;
}

export class TopicCardTemplateTimeEntry {
	
	
    public HasTimeEntry : DataSignal<boolean>;
    public Label : DataSignal<string | null>;

    constructor();
    constructor(data : TopicCardTemplateTimeEntryOptions);
    constructor(data: TopicCardTemplateTimeEntryOptions | null = null) {
	    
	    
        this.HasTimeEntry = jsonableObservable(S.value<boolean>(data && data.HasTimeEntry !== undefined ? data.HasTimeEntry : false));
        this.Label = jsonableObservable(S.value<string | null>(data && data.Label !== undefined ? data.Label : null));
    }

    static key(obj : TopicCardTemplateTimeEntry) {
        return ;
    }
    
    static dataKey(obj : TopicCardTemplateTimeEntryOptions) {
        return ;
    }

    static update(obj : TopicCardTemplateTimeEntry, data : TopicCardTemplateTimeEntryOptions) {
        S.freeze(() => {
	        
	        
            if (data.HasTimeEntry !== undefined) obj.HasTimeEntry(data.HasTimeEntry);
            if (data.Label !== undefined) obj.Label(data.Label);
        });
    }
}



// WEBPACK FOOTER //
// ./server/models/TopicCardTemplateTimeEntry.ts